import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const MediumSvg = ({ color = "primary", ...rest }) => {
  return (
    <Svg
      fill="none"
      width="33"
      height="33"
      viewBox="-1.5 -5 33 40"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <Path
        fill={color}
        d="M8.5 7A8.5 8.5 0 108.5 24 8.5 8.5 0 108.5 7zM22 8A4 7.5 0 1022 23 4 7.5 0 1022 8zM28.5 9A1.5 6.5 0 1028.5 22 1.5 6.5 0 1028.5 9z"
      />
    </Svg>
  )
}

export default MediumSvg
